//==============================================
// FORMATS BYTES INTO FRIENDLY FILE SIZE
//==============================================
export function formatBytes(bytes: number, decimals?: number): string {
    if (bytes === 0) return '0 Bytes'

    const k = 1024,
        dm = decimals <= 0 ? 0 : decimals || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

//==============================================
// FORMATS A NUMBER WITH PROPER COMMAS
//==============================================
export function formatNumber(num: number): string|undefined {
    // returns number formatted with commas
    if (!num) return undefined
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
